module.exports = __webpack_public_path__ + "assets/e532a32bc5a0f6b3abab700a121d8df5.png";